import './bootstrap';
import { createApp, h } from 'vue';
import Login from './Web/Login.vue';
import { apolloProvider } from './config/apollo';

createApp({
  render: () => h(Login),
})
.use(apolloProvider)
.mount('.web-app');